// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._39hnv{margin-top:1rem;display:grid;grid-gap:24px;gap:24px;grid-gap:1.5rem;gap:1.5rem;grid-template-columns:auto minmax(0,1fr);color:#231815}@media(max-width:767px){._39hnv{grid-template-columns:1fr}}._1nf3C{width:140px;width:8.75rem;height:140px;height:8.75rem;-o-object-fit:cover;object-fit:cover;border-radius:.5rem}._1nf3C,.aY0bd{cursor:pointer}.aY0bd{color:#231815;margin-bottom:1rem;font-size:18px;font-weight:500;line-height:25px;font-family:var(--heading-font);letter-spacing:.5px}._125Ev{color:#9fa0a0;margin:0 .5rem}._1ECqD{margin-bottom:.5rem;font-size:16px;font-weight:500;line-height:20px;font-family:var(--heading-font);letter-spacing:.5px}._1m5Mc{margin-bottom:1rem;display:-webkit-box;overflow:hidden;white-space:normal;-webkit-line-clamp:3;-webkit-box-orient:vertical;font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._1m5Mc{font-size:16px;line-height:26px}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_39hnv",
	"avatar": "_1nf3C",
	"name": "aY0bd",
	"dot": "_125Ev",
	"content": "_1ECqD",
	"description": "_1m5Mc"
};
module.exports = exports;
